package uz.ferro.erp.feature.utils

private fun String.escapeXml(): String {
    return this.replace("&", "&amp;")
        .replace("<", "&lt;")
        .replace(">", "&gt;")
        .replace("\"", "&quot;")
        .replace("'", "&apos;")
}

fun String.replaceProp(key: String, value: String?): String {
    return this.replace("{{$key}}", value.orEmpty().escapeXml())
}

fun <T> String.repeatBlock(key: String, items: List<T>, block: (String, T) -> String): String {
    val out = this
    val startToken = "{{$key##start}}"
    val endToken = "{{$key##end}}"

    val startTokenIndex = out.indexOf(startToken)
    if (startTokenIndex == -1) return out
    val prefix = out.take(startTokenIndex)

    val repeatStartIndex = startTokenIndex + startToken.length
    val repeatEndIndex = out.indexOf(endToken, repeatStartIndex)
    if (repeatEndIndex == -1) return prefix
    val repeatText = out.substring(repeatStartIndex, repeatEndIndex)
    val suffixStartIndex = repeatEndIndex + endToken.length
    val suffix = out.substring(suffixStartIndex)

    val sb = StringBuilder()
    sb.append(prefix)
    items.forEach { items ->
        sb.append(block(repeatText, items))
    }
    sb.append(suffix)
    return sb.toString()
}